(() => {
  const enhance = () => {
    const root = document.querySelector('#reviews-wrapper > .trustoo-widget[not-wdo-rev]');
    if (!root) return;
    root.dataset.ptCompact = 'true';
    const track = root.querySelector('.tt-review-list');
    if (!track || track.dataset.ptSlider) return;
    track.dataset.ptSlider = 'true';
    track.tabIndex = 0;
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', 'Klientų atsiliepimai');
    const controls = document.createElement('div');
    controls.className = 'pt-review-controls';
    const previous = document.createElement('button');
    const next = document.createElement('button');
    previous.type = next.type = 'button';
    previous.textContent = '‹';
    next.textContent = '›';
    previous.setAttribute('aria-label', 'Ankstesnis atsiliepimas');
    next.setAttribute('aria-label', 'Kitas atsiliepimas');
    controls.append(previous, next);
    track.before(controls);
    let maxScroll = 0;
    let updateFrame = 0;
    const update = () => {
      updateFrame = 0;
      const position = track.scrollLeft;
      previous.disabled = position <= 1;
      next.disabled = position >= maxScroll - 1;
      controls.hidden = maxScroll <= 1;
    };
    const scheduleUpdate = () => {
      if (!updateFrame) updateFrame = requestAnimationFrame(update);
    };
    const measure = () => {
      maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      scheduleUpdate();
    };
    const move = (direction) => {
      const card = track.querySelector('.list-review');
      const distance = card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
      track.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', scheduleUpdate, {passive:true});
    new ResizeObserver(measure).observe(track);
    measure();
  };
  let enhanceFrame = 0;
  let observedRoot = null;
  const scheduleEnhance = () => {
    if (enhanceFrame) return;
    enhanceFrame = requestAnimationFrame(() => {
      enhanceFrame = 0;
      enhance();
      const root = document.querySelector('#reviews-wrapper');
      if (root && root !== observedRoot) {
        observer.disconnect();
        observer.observe(root, {childList:true, subtree:true});
        observedRoot = root;
      }
    });
  };
  const observer = new MutationObserver(scheduleEnhance);
  observer.observe(document.body, {childList:true, subtree:true});
  document.addEventListener('onTrustooReviewsEmbed', scheduleEnhance);
  scheduleEnhance();
})();
